// extracted by mini-css-extract-plugin
export default {"group":"nW0X33twvWIeGk9yNnQQ","title":"UCEgaBLWRSQniKxBNhUZ"};